import { render, staticRenderFns } from "./RepairCost.vue?vue&type=template&id=54f2da4d&scoped=true"
import script from "./RepairCost.vue?vue&type=script&lang=js"
export * from "./RepairCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f2da4d",
  null
  
)

export default component.exports